const es_resource = {
	navbar: {
		home: 'Inicio',
		dashboard: 'Panel',
		quotes: 'Citas',
		document: 'Documento',
		user: 'Usuario',
		login: 'Acceso',
		logout: 'Cerrar sesión',
		change_password: 'Cambiar la contraseña'
	},
	header: {
		logout_confirmation: "¿Estás seguro que deseas cerrar la sesión?",
		assigned_roles: "Roles asignados"
	},
	dashboard: {
		name: 'Panel',
		title: 'Bienvenido al panel de ERP',
		subtitle: 'Instale o agregue más aplicaciones a su biblioteca'
	},
	quotes: {
		name: 'Citas',
		title: 'Este es el panel de cotizaciones',
		// quote_page: "This is Quotes page"
		quote_page: 'Esta es la página de Cotizaciones'
	},
	user: {
		name: 'Usuario',
		title: 'Este es el módulo USUARIO'
	},
	document: {
		name: 'Documento',
		title: 'Este es el módulo DOCUMENTO'
	},
  crm: {
    name: "Gestión de Relaciones con Clientes",
	title: "Este es el módulo de Gestión de Relaciones con Clientes",
    leads: {
		title: "Clientes Potenciales",
		add_label: "Agregar Nuevo Cliente Potencial",
		edit_label: "Editar Cliente Potencial",
		msg: {
		save: "Cliente potencial guardado exitosamente.",
		delete: "Cliente potencial eliminado exitosamente.",
		error: "Ocurrió un error al procesar el cliente potencial.",
		},
		sections: {
		generalDetail: "Detalle General",
		address: "Dirección",
		contact: "Contacto",
		followUp: "Seguimiento",
		ownerDetails: "Detalles del Propietario del Cliente",
		classification: "Clasificación",
		attachments: "Archivos Adjuntos",
		},
		fields: {
		type_lable: "Tipo",
		id_label: "ID",
		id_placeholder: "Ingrese el ID",
		firstName_label: "Nombre",
		firstName_placeholder: "Ingrese el Nombre",
		middleName_label: "Segundo Nombre",
		middleName_placeholder: "Ingrese el Segundo Nombre",
		lastName_label: "Apellido",
		lastName_placeholder: "Ingrese el Apellido",
		name_label: "Nombre",
		type_label: "Tipo",
		name_placeholder: "Ingrese el Nombre del Cliente Potencial",
		lead_company_label: "Empresa del Cliente Potencial",
		company_label: "Empresa",
		company_placeholder: "Ingrese el Nombre de la Empresa",
		phone_label: "Teléfono",
		phone_placeholder: "Ingrese el Número de Teléfono",
		email_label: "Correo Electrónico",
		email_placeholder: "Ingrese el Correo Electrónico",
		website_label: "Sitio Web",
		website_placeholder: "Ingrese la URL del Sitio Web",
		status_label: "Estado",
		status_placeholder: "Seleccione el Estado",
		conversion_probability_label: "Probabilidad de Conversión",
		reference_number_label: "Número de Referencia",
		reference_number_placeholder: "Ingrese el Número de Referencia",
		leadSource_label: "Fuente",
		leadSource_placeholder: "Seleccione la Fuente",
		salesPerson_label: "Vendedor",
		salesPerson_placeholder: "Seleccione el Vendedor",
		phoneNumber_label: "Número de Teléfono",
		phoneNumber_placeholder: "Ingrese el Número de Teléfono",
		industry_label: "Industria",
		industry_placeholder: "Seleccione la Industria",
		currency_label: "Moneda",
		currency_placeholder: "Seleccione la Moneda",
		priority_label: "Prioridad",
		priority_placeholder: "Seleccione la Prioridad",
		narration_label: "Narración",
		narration_placeholder: "Ingrese Notas o Narración",
		location_label: "Ubicación",
		location_placeholder: "Seleccione la Ubicación",
		department_label: "Departamento",
		department_placeholder: "Seleccione el Departamento",
		annualRevenue_label: "Ingresos Anuales",
		annualRevenue_placeholder: "Ingrese los Ingresos Anuales",
		view_attachment_label: "Archivo Adjunto",
		responsible_person_label: "Responsible Person",
        responsible_person_placeholder: "Select Responsible Person",
		customer_label: "Cliente",
		lead_status_label: "Estado del Cliente Potencial",
		},
		table: {
		id_header: "ID",
		name_header: "Nombre",
		company_header: "Empresa",
		status_header: "Estado",
		lead_status_header: "Estado del Cliente Potencial",
		owner_header: "Propietario",
		source_header: "Fuente",

		followUpType_header: "Tipo de Seguimiento",
		followUpDateTime_header: "Fecha y Hora del Seguimiento",
		remindMe_header: "Recordarme",
		description_header: "Descripción",

		addressType_header: "Tipo de Dirección",
		addressee_header: "Destinatario",
		defaultShippingAddress_header: "Dirección de Envío Predeterminada",
		defaultBillingAddress_header: "Dirección de Facturación Predeterminada",
		countryCode_header: "Código del País",
		contactNumber_header: "Número de Contacto",
		addrressOne_header: "Dirección 1",
		addressTwo_header: "Dirección 2",
		addressThree_header: "Dirección 3",
		zipCode_header: "Código Postal",
		city_header: "Ciudad",
		state_header: "Estado",
		country_header: "País",
		summary_header: "Resumen",

		email_header: "Correo Electrónico",
		},
		tabs: {
		basicDetails: "Detalles Básicos",
		address: "Dirección",
		contact: "Contacto",
		},
	},
  },
};

export default es_resource;
